export default __webpack_public_path__ + "static/media/think-different1440.c535475d.jpg";